import { DateFormats } from 'infrastructure/enums';
import CalendarIcon from 'assets/img/calendar.svg?react';
import { DateFormatter } from 'infrastructure/functions';
import BaseDatePicker from 'components/atoms/datePicker';
import { useRef, useState, type FC } from 'react';
import { addDays, lastDayOfMonth } from 'date-fns';
import classNames from 'classnames';
import { useSetDueDate } from 'infrastructure/hooks/ccm/console';
import ButtonLoadingIcon from 'components/atoms/icons/buttonLoadingIcon';

import s from './styles.module.scss';

import type { PickerRef } from 'rc-picker';

interface DueDateCellProps {
  date: string | null;
  patientGuid: string;
}

const DueDateCell: FC<DueDateCellProps> = ({ date, patientGuid }) => {
  const [open, setOpen] = useState(false);
  const pickerRef = useRef<PickerRef>(null);
  const { setDueDate, isLoading } = useSetDueDate();

  const utcFormattedDate = date
    ? DateFormatter({
        date,
        format: DateFormats['MMM d, yyyy'],
        toUTC: true,
      })
    : '';

  const handleClick = () => {
    if (isLoading) return;
    pickerRef.current?.nativeElement.click();
  };

  return (
    <div
      className={classNames(s.wrapper, {
        [s.open]: open,
      })}
      onClick={handleClick}
    >
      <p>{utcFormattedDate}</p>
      {isLoading ? (
        <ButtonLoadingIcon className={s['spin-loading-icon']} />
      ) : (
        <CalendarIcon width={16} height={16} className={s.icon} />
      )}
      <BaseDatePicker
        ref={pickerRef}
        value={date ? new Date(utcFormattedDate) : null}
        open={open}
        style={{
          position: 'absolute',
          visibility: 'hidden',
          pointerEvents: 'none',
        }}
        onOpenChange={(o) => {
          setOpen(o);
        }}
        onChange={(_date, dateString) => {
          if (Array.isArray(dateString)) return;

          setDueDate({
            ccmDueDate: dateString,
            patientGuid,
          });
          handleClick();
        }}
        showNow={false}
        minDate={addDays(new Date(), 1)}
        maxDate={lastDayOfMonth(new Date())}
      />
    </div>
  );
};
export default DueDateCell;
